export default __webpack_public_path__ + "static/media/NWC_1.7a7ba09e.png";